import React from 'react';
import { ParallaxBanner } from 'react-scroll-parallax';
import { useNavigate } from 'react-router-dom'; 
import Landing from './Landing';

export default function Aboutus() {
  const navigate = useNavigate();

  const background = {
    image:
      "https://s3-us-west-2.amazonaws.com/s.cdpn.io/105988/banner-background.jpg",
    translateY: [0, 50],
    opacity: [1, 0.3],
    scale: [1.05, 1, "easeOutCubic"],
    shouldAlwaysCompleteAnimation: true
  };

  const headline = {
    translateY: [0, 30],
    scale: [1, 1.05, "easeOutCubic"],
    shouldAlwaysCompleteAnimation: true,
    expanded: false,
    children: (
      <div className="inset center">
        <h1 className="headline white tracking-widest font-bold">GEMX</h1>
      </div>
    )
  };

  const foreground = {
    image:
      "https://s3-us-west-2.amazonaws.com/s.cdpn.io/105988/banner-foreground.png",
    translateY: [0, 15],
    scale: [1, 1.1, "easeOutCubic"],
    shouldAlwaysCompleteAnimation: true
  };

  const gradientOverlay = {
    opacity: [0, 1, "easeOutCubic"],
    shouldAlwaysCompleteAnimation: true,
    expanded: false,
    children: <div className="gradient inset" />
  };

  return (
    <>
      <ParallaxBanner
        layers={[background, headline, foreground, gradientOverlay]}
        className="full relative"
      >
        <button
          onClick={() => navigate('/app')} 
          className="absolute top-4 left-4 text-white"
        >
           <img
          src="https://img.icons8.com/?size=100&id=40217&format=png&color=FFFFFF"
          alt="back"
          className="w-6 h-6"
        />
        </button>
      </ParallaxBanner>
      <Landing />
    </>
  );
};
